import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './style.scss';

class AnimationWrapper extends Component {
  constructor(props) {
    super(props);
    this._frameId = null;
    this._previousPos = 0;

    this.state = {
      pos: 0,
      reachedBottom: false,
    };
  }

  componentDidMount() {
    this.startLoop();
  }

  componentWillUnmount() {
    this.stopLoop();
  }

  startLoop = () => {
    if (!this._frameId) {
      this._frameId = window.requestAnimationFrame(this.loop);
    }
  };

  /* eslint-disable class-methods-use-this */
  getScrollPos = (element) => {
    if (typeof element.pageYOffset !== 'undefined') {
      return element.pageYOffset;
    }

    return element.scrollTop;
  };

  /* eslint-disable class-methods-use-this */
  getElementHeight = (element) => {
    if (typeof element.innerHeight !== 'undefined') {
      return element.innerHeight;
    }

    return element.clientHeight;
  };

  stopLoop = () => {
    window.cancelAnimationFrame(this._frameId);
  };

  loop = () => {
    const scrollPos = this.getScrollPos(window);
    let elementHeight = this.getElementHeight(this.node);
    let newPos = 0;

    // If getElementHeight returns 0, use the previous height.
    if (elementHeight === 0 && this.state.previousElementHeight) {
      elementHeight = this.state.previousElementHeight;
    }

    if (scrollPos > 0) {
      const diff = this._previousPos - scrollPos;
      newPos = this.state.pos + diff;
      newPos = Math.max(-elementHeight, Math.min(0, newPos));
    }

    const isVisible = newPos > -elementHeight;
    const hasReachedTop = scrollPos < 5 && isVisible;
    const hasReachedBottom = Math.round(scrollPos + window.innerHeight) >= document.body.clientHeight;
    const scrolledPastNavHeight = scrollPos > elementHeight;
    this.setState({
      pos: hasReachedBottom ? 0 : newPos,
      reachedTop: hasReachedTop,
      reachedBottom: hasReachedBottom,
    });

    this._previousPos = scrollPos;
    this.props.onUpdate(isVisible, hasReachedTop, scrolledPastNavHeight);

    // Set up next iteration of the loop.
    this._frameId = window.requestAnimationFrame(this.loop);
  };

  render() {
    const { reachedTop, reachedBottom, pos } = this.state;
    const { children, hasBackground, scrolledPastNavHeight } = this.props;

    const classes = classNames('AnimationWrapper', {
      'AnimationWrapper--hasBackground': hasBackground,
      's-scrolled-past-nav-height': scrolledPastNavHeight,
      's-reached-page-top': reachedTop,
      's-reached-page-bottom': reachedBottom,
    });
    return (
      <div
        ref={(node) => { this.node = node; }}
        className={classes}
        style={{ top: pos }}
      >
        {children}
      </div>
    );
  }
}

AnimationWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  onUpdate: PropTypes.func,
};

AnimationWrapper.defaultProps = {
  onUpdate: () => {},
};

export default AnimationWrapper;
